import React, { Component } from 'react';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import guid from '@/shared/utils/guid';
import config from '@/config';
import api from '@/shared/api';
import { hasAssignments } from '@/shared/components/security/HasAssignments';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import intlShape from '@/shared/utils/intlShape';
import Axios from 'axios';

const messages = defineMessages({
  AssignmentTemplate: 'Assignment template',
  DefaultAssignment: 'Default assignment',
});

class AssignmentTemplateSelector extends Component {
  state = {
    templates: [],
  };

  componentDidMount() {
    if (!hasAssignments()) return;
    this.cancelToken = Axios.CancelToken.source();
    const { intl } = this.props;
    api.base
      .get(`${config.appUrls.api}/api/AssignmentTemplate/Get`, {
        cancelToken: this.cancelToken.token,
      })
      .then(({ data }) => {
        const templates = data
          .map(x => ({
            ...x,
            code: x.code || '',
            label: `${x.code ? `${x.code} – ` : ''}${intl.formatMessage(
              listItemMsg('assignmenttemplate', x.id, x.name),
            )}`,
          }))
          .sort(dynamicSortMultiple('code', 'label'));

        this.setState({
          templates,
        });
      });
  }

  render() {
    const {
      intl,
      onChange,
      value,
      placeholder,
      showDefaultAssignment,
      customItems = [],
    } = this.props;
    const { templates } = this.state;

    if (!hasAssignments()) return null;

    const emptyObject =
      typeof placeholder !== 'undefined'
        ? placeholder
        : intl.formatMessage(messages.AssignmentTemplate);

    const allItems = [...(customItems || []), ...(templates || [])];

    return (
      <select
        value={value || ''}
        className="form-control"
        onChange={e => onChange(e.target.value || null)}
      >
        {!!emptyObject && <option value="">{emptyObject}</option>}
        {!!showDefaultAssignment && (
          <option value={guid.empty}>{intl.formatMessage(messages.DefaultAssignment)}</option>
        )}
        {allItems &&
          allItems.map(item => (
            <option key={item.id} value={item.id}>
              {item.label}
            </option>
          ))}
      </select>
    );
  }
}

AssignmentTemplateSelector.propTypes = {
  intl: intlShape.isRequired,
  onChange: PropTypes.func.isRequired,
  showDefaultAssignment: PropTypes.bool,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  customItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string,
    }),
  ),
};
AssignmentTemplateSelector.defaultProps = {
  value: null,
  placeholder: undefined, // Undefined will use standard placeholder, null or empty string will not display placeholder
  showDefaultAssignment: false,
  customItems: [],
};
export default injectIntl(AssignmentTemplateSelector);
